//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import angular from 'angular';
import React from 'react';

import makeAngularReactController from '@react-bridge/angular-react-widget';
import StreamsDrawerAssetFeedsCloseConfirmationModal from '@streams/components/StreamsDrawerAssetFeedsCloseConfirmationModal';

angular.module('curalate').component('streamsDrawerAssetFeedsCloseConfirmationModal', {
  controller: makeAngularReactController(<StreamsDrawerAssetFeedsCloseConfirmationModal/>),
});
